import React, { useState, useContext, useEffect } from 'react';

import "../../../ui-styles/bottomSlider/BottomSlider.css";
import "../../../ui-styles/prescription/prescriptionAdd.css";
import Button from "../../../lib/ui/buttons/Button";
import InputField from "../../../lib/ui/inputs/Input";
import DropDown from "../../../lib/ui/dropdown/Dropdown";
import Diagnosis from "../../../config/diagnosis.json";
import AddDrug from "./AddDrug";


import { LangCtx } from "../../../lib/context";

import "../../../ui-styles/picker/picker.css";

const PrescriptionModal = (props) => {
    const { l } = useContext(LangCtx);
    const [errorMsg, setErrorMsg] = useState(null);
    const [drugs, setDrugs] = useState([{
        drugname: '',
        takePerDose: '',
        drugType: '',
        medicalUnit: '',
        dose: '',
        whenDose: '',
        doseInDay: '',
        forDays: '',
        notes: ''
    }]);
    const [chiefComplaint, setChiefComplaint] = useState('');
    const [diagnosis, setDiagnosis] = useState('');
    const [investigation, setInvestigation] = useState('');
    const [remarks, setRemarks] = useState('');

    useEffect(() => {
        if (props.data != null) {
            setDrugs(props.data.drugs);
            setChiefComplaint(props.data.chiefComplaint);
            setDiagnosis(props.data.diagnosis);
            setInvestigation(props.data.investigation);
            setRemarks(props.data.remarks)
        }
    }, [props.data])

    const addDrug = () => {
        let drug = {
            drugname: '',
            takePerDose: '',
            drugType: '',
            medicalUnit: '',
            dose: '',
            whenDose: '',
            doseInDay: '',
            forDays: '',
            notes: ''
        }
        let _drugs = [...drugs];

        _drugs.push(drug);
        setDrugs(_drugs);
    }

    const removeDrug = (i) => {
        if (i > 0) {
            let _drugs = [...drugs];

            _drugs.splice(i, 1);
            setDrugs(_drugs);
        }
    }

    const handleChange = (name, value, i) => {
        let _drugs = [...drugs];

        _drugs[i] = {
            ..._drugs[i],
            [name]: value
        }
        setDrugs(_drugs);
    }

    const validateForm = () => {
        if (chiefComplaint === '' || chiefComplaint == null || diagnosis === '' || diagnosis == null) {
            setErrorMsg(l.pls_ent_comp)
            return false;
        }
        else if (investigation === '') {
            setErrorMsg('please add investigation');
            return false;
        }
        else if (remarks === '') {
            setErrorMsg('please add remarks');
            return false;
        }
        else {
            for (let i = 0; i < drugs.length; i++) {
                let number = i + 1 > 1 ? i + 1 + 'nd ' : i + 1 + 'st ';
                if (drugs[i].drugname === '') {
                    setErrorMsg(l.pls_enter+" " + number + l.entr_drug_name)
                    return false;
                }
                else if (drugs[i].takePerDose === '') {
                    setErrorMsg(l.pls_select + number + l.drug_per_dosage)
                    return false
                }
                else if (drugs[i].drugType === '') {
                    setErrorMsg(l.pls_select + number + l.drug_type)
                    return false
                }
                else if (drugs[i].medicalUnit === '') {
                    setErrorMsg(l.pls_select + number + l.drug_med_unit)
                    return false
                }
                else if (drugs[i].dose === '') {
                    setErrorMsg(l.pls_enter + number + l.drug_dosage)
                    return false
                }
                else if (drugs[i].doseInDay === '') {
                    setErrorMsg(l.pls_enter + number + l.drug_dose_day)
                    return false
                }
                else if (drugs[i].whenDose === '') {
                    setErrorMsg(l.pls_enter + number + l.drug_usage)
                    return false
                }
                else if (drugs[i].forDays === '') {
                    setErrorMsg(l.pls_enter + number + l.drug_no_days)
                    return false
                }
            }
            setErrorMsg(null);
            return true;

        }
    }

    const handlePrescription = (e) => {
        //  e.preventDefault();
        try {
            if (validateForm()) {
                //   setLoading(true);
                let body = {
                    chiefComplaint: chiefComplaint,
                    diagnosis: diagnosis,
                    drugs: drugs,
                    investigation: investigation,
                    remarks: remarks
                }
                props.handleCreateOrEdit(body);
                props.closeModal();
            }
        } catch (e) {
            //   setLoading(false);
            console.log("Error", e);
            setErrorMsg(l.went_worng_pls_try_again)
            props.closeModal();
        }
    }

    return (
        // <div className={props.open ? "btmSlider slideUp" : "btmSlider"}>
            <div className={props.open ? (props?.current === "PRC" ? "btmSlidervisitInfo slideUp" : "btmSlider slideUp")
  : (props?.current === "PRC" ? "btmSlidervisitInfo" : "btmSlider")}>
            <div className="btmSliderPaper">
                <div className="btmSliderHdr">
                    <div className="btmHeaderRow">
                        <div className="hdrTxtGroup" onClick={props.closeModal}>
                            <span className="hdrBtnTxt">{l.cancel}</span>
                        </div>
                        <div className="hdrTxtGroup" onClick={handlePrescription}>
                            <span className="hdrBtnTxt">{l.save}</span>
                        </div>
                    </div>
                </div>
                <div className="btmSliderBdy">
                    {errorMsg &&
                        <div className="errorBox">
                            <small className="errorTxt">{errorMsg}</small>
                        </div>
                    }
                    <div className="elemtGroup">
                        <h2 className="hdrTxtMd">{l.add_drug_desc}</h2>
                    </div>
                    <div className="inputInlineGroup">
                        <div className="inputInlineItem">
                            <InputField
                                placeholder={l.inp_chief_comp}
                                type="text"
                                maxLength="100"
                                value={chiefComplaint}
                                onChange={(e) => {
                                    setErrorMsg("");
                                    setChiefComplaint(e.target.value)
                                }}
                            />
                        </div>
                        <div className="inputInlineItem">
                            <DropDown
                                placeholder={l.diagnosis}
                                items={Diagnosis}
                                value={diagnosis}
                                type="text"
                                onChange={(e) => setDiagnosis(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="presAddCntnr mrgTop8">
                        {drugs && drugs.map((drug, i) => <AddDrug key={i} index={i} handleChange={handleChange} data={drug} removeDrug={removeDrug} />)}
                        <div className="presBtmActn">
                            <Button
                                size="sm"
                                type="primary"
                                onClick={addDrug}
                                label={l.add_more}
                            />
                        </div>
                    </div>
                    <div className="inputInlineGroup mrgTop8">
                        <div className="inputInlineItem">
                            <InputField
                                maxLength="50"
                                placeholder={l.inp_investigation}
                                type="text"
                                value={investigation}
                                onChange={(e) => {
                                    setErrorMsg("");
                                    setInvestigation(e.target.value)}}
                            />
                        </div>
                        <div className="inputInlineItem">
                            <InputField
                                placeholder={l.inp_remarks}
                                type="text"
                                maxLength="100"
                                value={remarks}
                                onChange={(e) => {
                                    setErrorMsg("");
                                    setRemarks(e.target.value)}}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default PrescriptionModal;